


















































import Vue from 'vue'
import { PlayerGameStatus } from '../types'
import Coin from './Coin.vue'

function compareScoring(a: any, b: any) {
  if (a.pointsTotal > b.pointsTotal) {
    return -1
  }
  if (a.name > b.name) {
    return 1
  }
  return 0
}

export default Vue.extend({
  name: 'PlayerList',
  props: ['status', 'connections', 'scoring', 'applicationsPicked'],
  components: {
    Coin,
  },
  data: function() {
    return {
      theplayerGameStatus: PlayerGameStatus,
    }
  },
  computed: {
    orderedPlayers() {
      const scoringClone = Object.values(this.scoring)
      console.log(scoringClone)
      scoringClone.sort(compareScoring)

      console.log(scoringClone)
      return scoringClone
    },
  },
})
